module.exports = __webpack_public_path__ + "static/media/756MeldrumStNW_2018-06-18_120.3c3505c0.jpg";